var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32ZM96 18.2857C83.3764 18.2857 73.1429 28.5192 73.1429 41.1429C73.1429 53.7665 83.3764 64 96 64C108.624 64 118.857 53.7665 118.857 41.1429C118.857 28.5192 108.624 18.2857 96 18.2857ZM17.4821 87.8521C17.4821 79.7136 24.0797 73.1161 32.2181 73.1161H88.1233C96.2617 73.1161 102.859 79.7136 102.859 87.8521V113.263C102.859 121.402 96.2617 127.999 88.1233 127.999H32.2181C24.0797 127.999 17.4821 121.402 17.4821 113.263V87.8521ZM126.893 89.1295C126.893 85.3424 123.823 82.2723 120.036 82.2723C116.249 82.2723 113.179 85.3424 113.179 89.1295V111.987C113.179 115.774 116.249 118.844 120.036 118.844C123.823 118.844 126.893 115.774 126.893 111.987V89.1295Z",
    fill: "#D99A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a33758e86461c4ea556758079010bede.svg";
export { ForwardRef as ReactComponent };